<template>
  <v-card :elevation="1"
          rounded="lg"
          class="pa-4"
          style="height:100%; width:100%; overflow: scroll">
    <div class="font-weight-bold text-lg">
      {{ conf.title }}
    </div>
    <v-data-table class="mt-3"
                  :loading="items.length < 1 && loading"
                  :headers="headers"
                  :items="items"
                  item-key="prestationId"
                  hide-default-footer
                  disable-pagination
                  v-if="items.length > 0"
    >
      <template v-slot:body="{ items }">
        <tbody>
        <tr
            v-for="(item, index) in items"
            :key="index"
        >
          <td class="">{{ item.name }}</td>
          <td class="">
            <div class="">
              <v-chip @click="openBooking(item)"
                      label
                      flat
                      small
                      outlined
                      class="grey lighten-2 blue--text text--lighten-2 "
              >
                <v-icon small class="mr-2">mdi-open-in-new</v-icon>
                {{ item.bookingId }}
              </v-chip>
            </div>
          </td>
          <td>
            <div class="d-flex ">{{
                _parseAndFormatDate(item.bookingDate, "yyyy-MM-dd", 'dd/MM/yyyy')
              }}
            </div>
          </td>
          <td class="">
            <div class="">
              {{ item.prestationId }}
            </div>
          </td>
          <td>
            <div class="d-flex flex-column  caption">{{
                _parseAndFormatDate(item.startDate, "yyyy-MM-dd", 'dd/MM/yyyy')
              }} -
              {{
                _parseAndFormatDate(item.stopDate, "yyyy-MM-dd", 'dd/MM/yyyy')
              }}
            </div>
          </td>
          <td class="text-right">
            <v-chip @click="openInvoice(item)"
                    label
                    flat
                    small
                    outlined
                    class="grey lighten-2 blue--text text--lighten-2 "
            >
              <v-icon small class="mr-2">mdi-open-in-new</v-icon>
              {{ item.invoiceId }}
            </v-chip>
          </td>

        </tr>
        </tbody>

      </template>


    </v-data-table>
  </v-card>
</template>
<script>
import {EventBus} from "@/components/commons/event-bus";
import {get, post} from "@/utils/api";
import {addDays} from "date-fns";
// Détails CA par site
export default {
  name: "PrestationCancelledReplaceWithprovision",

  data() {
    return {
      loading: false,
      items: [],
      headers: [
        {
          text: "Nom",
          value: "name",
          align: "left",
          sortable: false,
        },
        {
          text: "Dossier",
          value: "bookingId",
          align: "left",
          sortable: false,
        },
        {
          text: "Date résa",
          value: "bookingDate",
          align: "left",
          sortable: false,
        },
        {
          text: "Prestation",
          value: "prestationId",
          align: "left",
          sortable: false,
        },
        {
          text: "Dates séjour",
          value: "startDate",
          align: "left",
          sortable: false,
        },

        {
          text: "Facture",
          value: "invoiceId",
          align: "right",
          sortable: false,
        },
      ],
      url: `/api/widget/bookings/partial-invoice`,
      totaux: {},
      totauxPast: {}
    }
  },
  props: {
    form: {type: Object, required: true},
    conf: {type: Object, required: false, default: null}
  },
  created() {
    this.init()
    EventBus.$on('searchDashboard', () => this.init());
  },
  computed: {},
  methods: {
    init() {
      const body = {
        startDateAct: this.form.startDateAct ?? this._formatDate(new Date(), 'yyyy-MM-dd'),
        stopDateAct: this.form.stopDateAct ?? this._formatDate(new Date(), 'yyyy-MM-dd'),
        startDateOld: "2024-01-01",//this.form.startDateOld ?? this._formatDate(new Date(), 'yyyy-MM-dd'),
        stopDateOld: this.form.stopDateOld ?? this._formatDate(new Date(), 'yyyy-MM-dd'),
        destinations: [],
        sites: [],
        commercialIds: [],
        allAgencies: false,
        bookingStatus: null
      }
      this.items = []
      post(this.url, body, {"Content-Type": "application/json"})
          .json(r => {
            this.items = r
            console.log(this.items)
          })
    },
    openBooking(item) {
      let route = this.$router.resolve({
        name: "Booking",
        params: {id: item.bookingId},
      });
      window.open(route.href, "_blank");

    },
    openInvoice(item) {
      let route = this.$router.resolve({
        name: "supplier-invoice",
        params: {id: item.invoiceId},
      });
      window.open(route.href, "_blank");
    },
    sum(accumulator, a) {
      return accumulator + a;
    },
  },

}
</script>


